import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Button, Alert } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import useHeaderGenerator from 'components/app/common/functions/useHeaderGenerator';
import FormModal from 'components/app/common/FormModal';
import TemplateService from './TemplateService';
import schema from './jsonSchema';
import { Modal, Form, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
const formatDate = inputDate => {
  const date = new Date(inputDate);
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  };

  const formattedDate = date.toLocaleDateString('en-US', options);
  return formattedDate;
};

const TemplateDetails = () => {
  const { identifier } = useParams();
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [data, setData] = useState();
  const [isCreatingClasses, setIsCreatingClasses] = useState(false);
  const [classCreationMessage, setClassCreationMessage] = useState(null);
  const [classCreationError, setClassCreationError] = useState(null);
  const [showDeleteClasses, setShowDeleteClasses] = useState();
  const showValue = attributeName => {
    return data[attributeName];
  };

  const handleCreateClasses = async () => {
    setIsCreatingClasses(true);
    setClassCreationMessage(null);
    setClassCreationError(null);

    try {
      const result = await TemplateService.createClassesFromTemplate(
        identifier
      );
      setClassCreationMessage(`Successfully created ${result.count} classes!`);
      setIsCreatingClasses(false);
    } catch (error) {
      console.error('Error creating classes:', error);
      setClassCreationError('Failed to create classes. Please try again.');
      setIsCreatingClasses(false);
    }
  };

  useEffect(() => {
    TemplateService.retrieveTemplate(identifier)
      .then(data => {
        setData(data);
        console.log('Data', data);
      })
      .catch(error => {
        console.error('Error retrieving Template', error);
      });
  }, []);

  const buttonsConf = [
    {
      name: 'Edit Template',
      type: 'button',
      icon: 'edit',
      variant: 'info',
      onClick: () => {
        console.log('Edit this data');
        navigate('/app/wod/templates/' + identifier + '/edit');
      }
    },
    {
      name: 'Create Classes',
      type: 'button',
      icon: 'calendar-plus',
      variant: 'success',
      onClick: handleCreateClasses,
      disabled: isCreatingClasses
    },
    {
      name: 'Delete classes',
      icon: 'delete',
      type: 'button',
      variant: 'danger',
      onClick: () => {
        setShowDeleteClasses(true);
      }
    }  
  ];

  const jsonSchema = schema;
  const headerGenerated = useHeaderGenerator('Template', ' ', buttonsConf);

  return (
    <>
      {headerGenerated}
      {modalShow && (
        <FormModal
          message={'Template has been updated!'}
          modalShow={modalShow}
          setModalShow={setModalShow}
        />
      )}
      {isCreatingClasses && (
        <Alert variant="info" className="d-flex align-items-center">
          <Spinner animation="border" size="sm" className="me-2" />
          Creating classes from template, please wait...
        </Alert>
      )}
      {classCreationMessage && (
        <Alert
          variant="success"
          dismissible
          onClose={() => setClassCreationMessage(null)}
        >
          {classCreationMessage}
        </Alert>
      )}
      {classCreationError && (
        <Alert
          variant="danger"
          dismissible
          onClose={() => setClassCreationError(null)}
        >
          {classCreationError}
        </Alert>
      )}
      {data && (
        <>
          <Card>
            <Card.Body>
              {jsonSchema.map(field => {
                if (field.type === 'group') {
                  return field.fields.map(f => (
                    <Row key={f.name}>
                      <Col xs={5} sm={4}>
                        <p className="fw-semi-bold mb-1">{f.label + ': '}</p>
                      </Col>
                      <Col>{showValue(f.name)}</Col>
                    </Row>
                  ));
                } else {
                  return (
                    <Row key={field.name}>
                      <Col xs={5} sm={4}>
                        <p className="fw-semi-bold mb-1">
                          {field.label + ': '}
                        </p>
                      </Col>
                      <Col>{showValue(field.name)}</Col>
                    </Row>
                  );
                }
              })}
            </Card.Body>
          </Card>
          <Card className="mt-2">
            <Card.Header>
              <h5>Days</h5>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col>Day</Col>
                <Col>Coach</Col>
                <Col>Max Capacity</Col>
                <Col>Cancellation Policy Hours</Col>
              </Row>
              {data.days.map(d => (
                <Row>
                  <Col>{d.dayOfWeek}</Col>
                  <Col>{d.coach}</Col>
                  <Col>{d.maxCapacity}</Col>
                  <Col>{d.cancellationPolicyHours}</Col>
                </Row>
              ))}
            </Card.Body>
          </Card>
          {data && <DeleteClassesModal
            show={showDeleteClasses}
            onHide={() => setShowDeleteClasses(false)}
            template={data}
          />}
        </>
      )}
    </>
  );
};
const DeleteClassesModal = ({ show, onHide, template }) => {
  const [type, setType] = useState(template.name);
  const identifier = template.identifier;
  const [fromDate, setFromDate] = useState(template.startDate);
  const [toDate, setToDate] = useState(template.endDate);
  const [loading, setLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleDeleteClick = () => {
    if (!identifier || !fromDate || !toDate) {
      toast.error('Please fill in all fields', { theme: 'colored' });
      return;
    }
    setShowConfirmation(true);
  };

  const handleConfirmDelete = async () => {
    setLoading(true);
    try {
      await TemplateService.deleteClassesFromTemplate(identifier, fromDate, toDate);
      toast.success(
        `Classes for ${type} were deleted from ${fromDate} to ${toDate}`,
        { theme: 'colored' }
      );
      setShowConfirmation(false);
      onHide();
      // Reset form
      setIdentifier('');
      setType('');
      setFromDate('');
      setToDate('');
    } catch (error) {
      toast.error('Error deleting classes: ' + error.message, {
        theme: 'colored'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShowConfirmation(false);
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Delete Classes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!showConfirmation ? (
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>From Date</Form.Label>
              <Form.Control
                type="date"
                value={fromDate}
                onChange={e => setFromDate(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>To Date</Form.Label>
              <Form.Control
                type="date"
                value={toDate}
                onChange={e => setToDate(e.target.value)}
                required
              />
            </Form.Group>
          </Form>
        ) : (
          <div className="text-center">
            <h5>Are you sure you want to delete these classes?</h5>
            <p>
              You're about to delete all {type} classes from {fromDate} to{' '}
              {toDate}. This action cannot be undone.
            </p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        {!showConfirmation ? (
          <>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={handleDeleteClick}
              disabled={loading}
            >
              Delete Classes
            </Button>
          </>
        ) : (
          <>
            <Button
              variant="secondary"
              onClick={() => setShowConfirmation(false)}
              disabled={loading}
            >
              Go Back
            </Button>
            <Button
              variant="danger"
              onClick={handleConfirmDelete}
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Deleting...
                </>
              ) : (
                'Yes, Delete Classes'
              )}
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};
export default TemplateDetails;
